/**
 * 403. Rendered in place, never as a redirect to sign-in — a redirect makes the user think their
 * session died and hand the device to someone else to "fix" it.
 */

import { useNavigate } from 'react-router';

import { Button } from '@/shared/ui';

export function ForbiddenPage({ required = [] }: { required?: readonly string[] }) {
  const navigate = useNavigate();

  return (
    <div className="grid h-full place-items-center px-6 py-[3.5rem] text-center">
      <div>
        <h1 className="text-xl font-bold text-content-primary">You do not have access to this</h1>
        <p className="mx-auto mt-3 max-w-[36ch] text-sm text-content-secondary">
          Your role does not include this screen. Ask the owner to add it if you need it — you are
          still signed in.
        </p>

        {required.length > 0 && (
          <p className="mt-3 text-xs text-content-muted">
            Needs: <span data-nums="id">{required.join(', ')}</span>
          </p>
        )}

        <Button variant="quiet" className="mt-6" onClick={() => void navigate('/sell')}>
          Back to selling
        </Button>
      </div>
    </div>
  );
}
